import React from "react";
const Unauthorized: React.FC = () => {

    return (
        <div className="unauthorised-input">
            <h1 className="color">Access denied</h1>
            <span className="text-spacing">You dont have access to this page</span>
        </div>
    );
}
export default Unauthorized;